(function($) {
	'use strict';

	$.widget('msv.breadcrumbs', {

		vars: {
			timer: 0,
			offset: null
		},
		el: {
			previousElement: null,
		},

		getOffset: function() {
			var self = this;
			var currentScroll = $(window).scrollTop();
			var menuHeight = $('.menu').height();
			var menuDouble = $('.menu__double');
			var menuDoubleHeight = $('.menu__double').height();
			var heroHeight = self.el.previousElement.height();
			if (menuDouble.length) {
				return currentScroll > heroHeight + menuHeight + menuDoubleHeight ? menuHeight + menuDoubleHeight : heroHeight + menuHeight + menuDoubleHeight;
			}
			else {
				return currentScroll > heroHeight + menuHeight ? menuHeight : heroHeight + menuHeight;
			}

		},

		_create: function() {
			var self = this;
			self.el.previousElement = $(this.element.data('previous-element'));
		},
		_init: function() {
			var self = this;
			$(window).on('scroll', function() {
				self.vars.timer = setTimeout(function() {

					if ($(window).scrollTop() >= self.getOffset())
						self.element.addClass('fixed').css('top', self.getOffset())
					else
						self.element.removeClass('fixed').removeAttr('style')

				}, 100)
			})
		}

	});

})(jQuery);